/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_EmptyInputs */

const cs_ruian_empty = /** @type {(inputs: Ruian_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné adresy.`)
};

const en_ruian_empty = /** @type {(inputs: Ruian_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No addresses found.`)
};

/**
* | output |
* | --- |
* | "No addresses found." |
*
* @param {Ruian_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_empty = /** @type {((inputs?: Ruian_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_empty(inputs)
	return cs_ruian_empty(inputs)
});